import React from "react";
import PageHeader from "../components/PageHeader";

export default function FunctionsAndPowers() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: "Functions & Powers", active: true },
  ];

  return (
    <div>
      {/* Page Header */}
      <PageHeader title="कार्य एवं शक्तियाँ" breadcrumbs={breadcrumbs} />

      {/* Functions & Powers Content */}
      <section className="container py-5">
        <div className="row">
          <h4 className="text-center fw-bold mb-4">
            आयोग के कार्य एवं शक्तियाँ
          </h4>
          <div className="col-12">

            <div className="info-block">
              <h6>1. कन्वेंशन अनुपालन का मूल्यांकन</h6>
              <p>
                बाल अधिकारों पर कन्वेंशन के अनुपालन का मूल्यांकन करने के लिए
                विद्यमान विधि, नीति और प्रथा का विश्लेषण करना।
              </p>
            </div>

            <div className="info-block">
              <h6>2. नीति एवं प्रथा की जाँच</h6>
              <p>
                शिशुओं को प्रभावित करने वाली प्रथा या नीति के किसी पहलू की
                जाँच-पड़ताल करना, प्रतिवेदन प्रस्तुत करना तथा बाल अधिकारों के
                परिप्रेक्ष्य में प्रस्तावित नये विधान पर मंतव्य देना।
              </p>
            </div>

            <div className="info-block">
              <h6>3. राज्य सरकार को प्रतिवेदन</h6>
              <p>
                बाल अधिकारों के संरक्षण से संबंधित उपायों की कार्य प्रणाली पर
                राज्य सरकार को वार्षिक एवं आवश्यक अंतरालों पर प्रतिवेदन
                प्रस्तुत करना।
              </p>
            </div>

            <div className="info-block">
              <h6>4. संवेदनशील बच्चों हेतु विशेष कार्यक्रम</h6>
              <p>
                हाशिए पर रहने वाले एवं संवेदनशील परिस्थितियों में ग्रस्त बच्चे जैसे बालिकाएँ, विमुक्त जाति, विशेष योग्यजन बच्चे, बाल मजदूर, निराश्रित बच्चे, मानव व्यापार एवं यौन उत्पीड़न के शिकार बच्चे, एचआईवी/एड्स से प्रभावित तथा आपदा पीड़ित बच्चों के लिए विशेष कार्यक्रम संचालित करना।
              </p>
            </div>

            <div className="info-block">
              <h6>5. राष्ट्रीय आयोग से समन्वय</h6>
              <p>
                बाल अधिकारों के संरक्षण हेतु राष्ट्रीय बाल अधिकार संरक्षण आयोग
                के साथ समन्वय एवं सहयोग स्थापित करना।
              </p>
            </div>

            <div className="info-block">
              <h6>6. अधिकार क्षेत्र की सीमाएँ</h6>
              <p>
                आयोग ऐसे किसी मुद्दे पर विचार या जाँच नहीं करेगा जो
                राष्ट्रीय आयोग या किसी अन्य सक्षम आयोग के विचाराधीन हों।
              </p>
            </div>

            <div className="info-block">
              <h6>7. औपचारिक जाँच-पड़ताल</h6>
              <p>
                जहाँ स्वयं बच्चों द्वारा या उनकी ओर से किसी संबंधित व्यक्ति
                द्वारा शिकायत की गई हो, वहाँ औपचारिक जाँच-पड़ताल करना।
              </p>
            </div>

            <div className="info-block">
              <h6>8. दिशा-निर्देश एवं प्रोटोकॉल</h6>
              <p>
                बाल अधिकारों से संबंधित कार्यक्रमों के लिए दिशा-निर्देश,
                प्रोटोकॉल एवं पारदर्शिता निर्धारित कर प्रशासनिक प्रक्रिया
                को बच्चों के प्रति जवाबदेह बनाना।
              </p>
            </div>

            <div className="info-block">
              <h6>9. विकास कार्यसूची में बाल अधिकार</h6>
              <p>
                बाल अधिकारों को सभी स्थानीय निकायों, संबंधित विभागों तथा
                समाज की विकास कार्यसूची के केंद्र में लाना।
              </p>
            </div>

            <div className="info-block">
              <h6>10. संस्थागत सुदृढ़ीकरण</h6>
              <p>
                परिवारों, समुदायों तथा बच्चों की देखभाल एवं संरक्षण के लिए
                जिम्मेदार संस्थाओं और एजेंसियों को सुदृढ़ करना।
              </p>
            </div>

            <div className="info-block">
              <h6>11. शिकायतों की जाँच हेतु सूचना प्राप्त करना</h6>
              <p>
                बाल अधिकार उल्लंघन की शिकायतों की जाँच के लिए आयोग राज्य सरकार
                या संबंधित प्राधिकरण से निर्धारित समय सीमा में सूचना या
                प्रतिवेदन माँग सकता है तथा आवश्यकता होने पर स्वयं जाँच कर सकता है।
              </p>
            </div>

            <div className="info-block">
              <h6>12. शिकायतकर्ता को सूचित करना</h6>
              <p>
                यदि आयोग संतुष्ट हो कि आगे जाँच आवश्यक नहीं है या
                अपेक्षित कार्रवाई प्रारंभ हो चुकी है, तो शिकायतकर्ता को
                तदनुसार सूचित करना।
              </p>
            </div>

            <div className="info-block">
              <h6>13. बच्चों के विचारों पर आधारित कार्य</h6>
              <p>
                यह सुनिश्चित करना कि आयोग के कार्य बच्चों के प्रत्यक्ष रूप से
                व्यक्त विचारों, प्राथमिकताओं और दृष्टिकोण पर आधारित हों।
              </p>
            </div>

            <div className="info-block">
              <h6>14. बच्चों की भागीदारी को बढ़ावा</h6>
              <p>
                बच्चों के विचारों को प्रोत्साहित करना, उनका सम्मान करना
                और उनसे संबंधित सभी निर्णयों में उन्हें गंभीरता से विचाराधीन रखना।
              </p>
            </div>

            <div className="info-block">
              <h6>15. आँकड़ों का संकलन एवं विश्लेषण</h6>
              <p>
                बच्चों से संबंधित आँकड़ों का संकलन एवं विश्लेषण करना तथा
                आवश्यकता होने पर विशेषज्ञों एवं शोध संस्थानों के सहयोग से
                विशेष अध्ययन कार्यक्रम संचालित करना।
              </p>
            </div>

            <div className="info-block">
              <h6>16. जागरूकता एवं प्रचार-प्रसार</h6>
              <p>
                बाल अधिकारों के संबंध में जानकारी विकसित करना तथा
                उनका प्रचार-प्रसार करना, जिसमें आयोग की वेबसाइट का
                निर्माण एवं संचालन भी शामिल है।
              </p>
            </div>

            <div className="info-block">
              <h6>17. प्रशिक्षण एवं पाठ्यक्रम में समावेशन</h6>
              <p>
                विद्यालय पाठ्यक्रम, शिक्षक प्रशिक्षण, पुलिस एवं अन्य
                सरकारी पदाधिकारियों के प्रशिक्षण में बाल अधिकारों के
                समावेशन को पूर्ण रूप से प्रोत्साहित करना।
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
